(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.querySelectorAll('.vus__view-toggle').forEach((toggle) => {
    const group = toggle.closest('.vus__group');
    const productGrid = group?.querySelector('.vus__product-grid');
    if (!productGrid) return;

    toggle.querySelectorAll('[data-product-view]').forEach((button) => {
      button.addEventListener('click', () => {
        const showGrid = button.dataset.productView === 'grid';
        productGrid.classList.toggle('is-grid', showGrid);

        toggle.querySelectorAll('[data-product-view]').forEach((viewButton) => {
          const selected = viewButton === button;
          viewButton.classList.toggle('is-active', selected);
          viewButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const imageButton = event.target.closest('[data-verdosa-image-direction]');
    if (imageButton) {
      const card = imageButton.closest('[data-verdosa-card]');
      const images = [...card.querySelectorAll('.verdosa-similar-card__image')];
      let index = Number(card.dataset.activeImage || 0);
      index += imageButton.dataset.verdosaImageDirection === 'next' ? 1 : -1;
      index = (index + images.length) % images.length;
      card.dataset.activeImage = index;
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
      card.querySelectorAll('[data-verdosa-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      card.querySelector('.verdosa-similar-card__more')?.classList.toggle('is-active', index > 2);
      return;
    }

    const railButton = event.target.closest('[data-verdosa-rail]');
    if (railButton) {
      const track = railButton.closest('.verdosa-similar__carousel').querySelector('[data-verdosa-track]');
      const card = track.querySelector('[data-verdosa-card]');
      const distance = card.getBoundingClientRect().width + 24;
      track.scrollBy({ left: railButton.dataset.verdosaRail === 'next' ? distance : -distance, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
